// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"b35468a6","205":"c5728dcb","285":"460fb734","336":"3ecd19eb","654":"7176554b","725":"c8952a0d","787":"214031eb","898":"b8b9ca22"}[chunkId] + ".chunk.js";
};